module.exports = __webpack_public_path__ + "static/media/innerLogo.cccd590d.png";